import axios from 'axios';

const API_URL = '/api/v1/registration-list';
const CHECK_UNIQ_NUMBER = '/check-uniq-number';
const CHECK_IS_VALID_NUMBER = '/check-is-valid-number';

const search = (searchModel) => {
	return axios.post(`${API_URL}/search`, searchModel);
};

const uploadCsv = (callCenterId, file) => {
	const formData = new FormData();
	formData.append('csv', file);

	return axios.post(`${API_URL}/upload-list?organizationId=${callCenterId}`, formData);
};

const checkUniqNumber = (callCenterId, phoneNumber, phoneId) => {
	return axios.get(`${API_URL}${CHECK_UNIQ_NUMBER}?organizationId=${callCenterId}&phoneNumber=${phoneNumber}&phoneId=${phoneId || ''}`);
};

const checkIsValidNumber = (phoneNumber) => axios.post(`${API_URL}${CHECK_IS_VALID_NUMBER}`, { phoneNumber });

export {
	search,
	uploadCsv,
	checkUniqNumber,
	checkIsValidNumber,
};
